import React, { forwardRef } from "react";
import { RCCRefModalProps } from "react-common-components";
import { useTranslation } from "src/context/Translations/context";
import Modal from "../Modal";
import TreeHierarchyMaps from "./TreeHierarchyMaps";
import IModalIHierarchyMaps from "./interface";

const ModalTreeHierarchyMaps: React.ForwardRefRenderFunction<RCCRefModalProps, IModalIHierarchyMaps> = ({
	checkLevelHierarchy,
	lastLevelHierarchy,
	register,
	unregister,
	onCallbackButtonRow,
	onClose,
	subtitle,
	title,
	onSubmit,
	footer,
	icon,
	nodeContent,
	selectOptions
}, ref) => {
	const { translate } = useTranslation();
	return(
		<Modal
			ref={ref}
			header={{
				title: title || translate("Hierarquia de mapas"),
				subtitle,
				icon: {
					name: icon || "map"
				}
			}}
			footer={footer || {
				showSaveButton: true,
				buttonLoadingText: translate("Carregando"),
				saveButtonText: translate("Confirmar"),
				cancelButtonText: translate("Cancelar")
			}}
			onSubmit={onSubmit}
			onClose={() => {
				if(onClose !== undefined)
					onClose();
			}}
			withoutForm
		>
			{nodeContent && nodeContent}
			<TreeHierarchyMaps
				register={register}
				unregister={unregister}
				checkLevelHierarchy = {checkLevelHierarchy}
				lastLevelHierarchy={lastLevelHierarchy}
				onCallbackButtonRow={onCallbackButtonRow} 
				selectOptions={selectOptions}
			/>
		</Modal>
	);};

export default forwardRef(ModalTreeHierarchyMaps);
